<script setup lang="ts"></script>

<template>
	<thead class="[&_tr]:border-b" :class="$attrs.class">
		<slot />
	</thead>
</template>
